/**
 * Marca persistente de "sessão bloqueada por inatividade". Sobrevive a F5: enquanto existir,
 * o `AuthInit` não renova o token e força novo login, em vez de reabrir a sessão bloqueada.
 */
const SESSION_LOCKED_STORAGE_KEY = 'kt-auth-session-locked'

export const markSessionLocked = () => {
  localStorage.setItem(SESSION_LOCKED_STORAGE_KEY, Date.now().toString())
}

export const clearSessionLocked = () => {
  localStorage.removeItem(SESSION_LOCKED_STORAGE_KEY)
}

export const isSessionLocked = () => localStorage.getItem(SESSION_LOCKED_STORAGE_KEY) !== null
